
export default function forEachElement(elements, handle) {
    if (typeof handle !== 'function') return;
    Array.prototype.forEach.call(elements, handle);
}
